const license = {
    not_installed: 'Bu örnekte lisans yüklü değil.',
    invalid_key: 'Lisans anahtarı geçersiz veya kurcalanmış.',
    expired_key: 'Lisans anahtarının süresi doldu. Yeni bir anahtar alıp yeniden yükleyin.',
};
export default Object.freeze(license);
